import { get, set, del } from 'idb-keyval';

/**
 * Indexed DB asynchronous DB to save much more than sessionStorage.
 */
export const indexedDBStorage = {
    getItem: async (key) => {
        return await get(key);
    },

    setItem: async (key, value) => {
        await set(key, value);
    },

    removeItem: async (key) => {
        await del(key);
    }
};
